export const roundTripMessage = (start) => ({
  type: 'signal:round:trip',
  data: {
    start,
  },
})

export const roundTripTime = (data) => ({
  ...data,
  type: 'signal:rtt',
})
